'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId from "./app.api.-Drug-Requests-Accepted-List-Item$-Id.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$125(evaluator$47) {
  this.Lapp_api_PharmacyAppUpdate$$anon$125__f_evaluator$23 = null;
  this.Lapp_api_PharmacyAppUpdate$$anon$125__f_evaluator$23 = evaluator$47;
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$125 as $c_Lapp_api_PharmacyAppUpdate$$anon$125 };
$c_Lapp_api_PharmacyAppUpdate$$anon$125.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$125.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$125;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$125() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$125 as $h_Lapp_api_PharmacyAppUpdate$$anon$125 };
$h_Lapp_api_PharmacyAppUpdate$$anon$125.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$125.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$125.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$125.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_PharmacyAppUpdate$$anon$125__f_evaluator$23.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId.$c_Lapp_api_DrugRequestsAcceptedListItem$Id) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_PharmacyAppUpdate$$anon$125.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$125 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$125, "app.api.PharmacyAppUpdate$$anon$125", ({
  Lapp_api_PharmacyAppUpdate$$anon$125: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$125 as $d_Lapp_api_PharmacyAppUpdate$$anon$125 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$125.js.map
